import React from "react"
import classnames from "classnames"
import { Nav, NavItem, NavLink, Col } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

export default function ThemeTabs({
  activeTab,
  toggleTab,
  loading = false,
  tabsData,
}) {
  const tabs = tabsData || []

  return (
    <Nav pills className="nav-pills-custom flex-wrap gap-2">
      {loading
        ? tabs.map((_, idx) => (
            <ThemePlaceholder
              key={idx}
              style={{
                width: 120,
                height: 40,
                borderRadius: 6,
                marginRight: 8,
              }}
            />
          ))
        : tabs.map(tab => (
            <NavItem key={tab.id}>
              <NavLink
                className={classnames({ active: activeTab === tab.id },'border')}
                onClick={() => toggleTab(tab.id)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {tab.icon && <i className={`${tab.icon} me-2`}></i>}
                {tab.label}
                {tab.count !== undefined && ` (${tab.count})`}
              </NavLink>
            </NavItem>
          ))}
    </Nav>
  )
}
